import { SET_CHARACTERS_DATA } from 'js/store/characters/Characters.actions.js';

import { parseData } from 'js/store/characters/Characters.parser.js';

const initState = {
  characterIds: [],
  charactersById: {},
};

const characters = (state = initState, action) => {
  let nextState = {};

  switch (action.type) {
    case SET_CHARACTERS_DATA: {
      const { charactersById, characterIds } = parseData(action.payload);
      nextState.characterIds = characterIds;
      nextState.charactersById = charactersById;
      return { ...state, ...nextState };
    }
  }
  return state;
};

export default characters;
